export const DEFAULT_FONT_SIZE = 'font-size: 16px';

export const INTEGRATOR_HEADER_FIRST_LINE = {
  class: 'font-weight-bold base-color',
  style: DEFAULT_FONT_SIZE,
};

export const INTEGRATOR_HEADER_SECOND_LINE = {
  class: 'font-weight-regular base-color',
  style: DEFAULT_FONT_SIZE,
};

export const INTEGRATOR_BODY_FIRST_LINE = {
  class: 'font-weight-regular foreground--text',
  style: DEFAULT_FONT_SIZE,
}

export const INTEGRATOR_BODY_SECOND_LINE = {
  class: 'font-weight-light foreground--text',
  style: DEFAULT_FONT_SIZE,
}